<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="">Поставщик</label>
          <div class="input-group">
            <input type="text" :value="invoice.supplier.title" disabled class="form-control">
            <div class="input-group-prepend">
              <span class="input-group-text">{{ $AllCurrencies[invoice.currency_id].currency }}</span>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="">Комментарий</label>
          <input
            type="text"
            placeholder="Комментарий к закупке"
            v-model="invoice.comment"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-md-6">
        <InvoiceDiscount :invoice="invoice"/>
      </div>
    </div>
  </div>
</template>

<script>

import InvoiceDiscount from "@/views/admin/invoices/components/InvoiceDiscount.vue";

export default {
  props: ['invoice'],
  components: {
    InvoiceDiscount,
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
  },
  data() {
    return {}
  }
}
</script>
